export default "/images/e6939eb6330c2b9c496fdd07afc56b2d.avif";